import { get } from 'lodash'

export default function(fields = {}, { isAssessor } = {}) {
  const model = {
    phone: get(fields, 'phone') === '+' ? undefined : get(fields, 'phone'),
    secondaryPhone: get(fields, 'secondaryPhone') === '+'
      ? undefined
      : get(fields, 'secondaryPhone'),
    title: get(fields, 'title'),
    firstName: get(fields, 'firstName'),
    lastName: get(fields, 'lastName'),
    email: get(fields, 'email'),
    secondaryEmail: get(fields, 'secondaryEmail'),
    tertiaryEmail: get(fields, 'tertiaryEmail'),
    address: {
      line1: get(fields, 'address.line1') || null,
      line2: get(fields, 'address.line2') || null,
      city: get(fields, 'address.city') || null,
      zipCode: get(fields, 'address.zipCode') || null,
      stateOrProvinceOrRegion: get(fields, 'address.stateOrProvinceOrRegion') ||
        null,
      country: get(fields, 'address.country.id')
        ? {
            id: get(fields, 'address.country.id')
          }
        : null
    },
    phoneType: {
      value: get(fields, 'phoneType.value')
    },
    secondaryPhoneType: {
      value: get(fields, 'secondaryPhoneType.value')
    },
    birthDate: get(fields, 'birthDate'),
    note: get(fields, 'note'),
    editCustomizationEnabled: get(fields, 'editCustomizationEnabled'),
    isExtendedRole: get(fields, 'isExtendedRole'),
    person: {
      ...fields.person,
      photoUrl: null,
      isTestUser: get(fields, 'isTestUser'),
      isMfaEnabled: get(fields, 'isMfaEnabled')
    }
  }

  if (isAssessor && fields.assessorDetail) {
    model.assessorDetail = {
      ...fields.assessorDetail,
      note: get(fields, 'note')
    }
  }

  if (
    !get(fields, 'address.line1') &&
    !get(fields, 'address.line2') &&
    !get(fields, 'address.city') &&
    !get(fields, 'address.zipCode') &&
    !get(fields, 'address.stateOrProvinceOrRegion') &&
    !get(fields, 'country')
  ) {
    model.address = undefined
  }
  return model
}
